import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SettingsPayrollEmployeeGroupFragment } from 'generated/resources/graphql'

import type LegalEntity from 'modules/core/store/models/LegalEntity'

import EmployeeGroups from './EmployeeGroups'
import EmployeeGroupsEmployees from './EmployeeGroupsEmployees'

interface Props {
  legalEntity: LegalEntity
  employeeGroups: SettingsPayrollEmployeeGroupFragment[]
}

const Employees = ({ legalEntity, employeeGroups }: Props) => {
  const [selectedEmployeeGroupId, setSelectedEmployeeGroupId] = React.useState(0)
  const findSelectedEmployeeGroup = (
    groups: SettingsPayrollEmployeeGroupFragment[]
  ): SettingsPayrollEmployeeGroupFragment | undefined => {
    const selected = groups.find((group) => group.id === selectedEmployeeGroupId)
    if (selected) return selected

    const defaultGroup = groups.find((group) => group.main)
    if (defaultGroup) return defaultGroup

    return employeeGroups[0]
  }
  const selectedEmployeeGroup = findSelectedEmployeeGroup(employeeGroups)

  return (
    <Box flexDirection="row" width="full" gap="s12">
      <Box borderRadius={{ all: 'abs008' }} flexGrow flexNoShrink>
        <EmployeeGroups
          legalEntity={legalEntity}
          employeeGroups={employeeGroups}
          selectedEmployeeGroup={selectedEmployeeGroup}
          selectEmployeeGroup={setSelectedEmployeeGroupId}
        />
      </Box>
      <Box borderRadius={{ all: 'abs008' }} flexGrow flexNoShrink background="grey200">
        {!!selectedEmployeeGroup && (
          <EmployeeGroupsEmployees selectedEmployeeGroup={selectedEmployeeGroup} />
        )}
      </Box>
    </Box>
  )
}

export default Employees
